import React from 'react';
import { Chip } from '@mui/material';
import {
  KeyboardDoubleArrowUp as UrgentIcon,
  KeyboardArrowUp as HighIcon,
  Remove as MediumIcon,
  KeyboardArrowDown as LowIcon,
} from '@mui/icons-material';
import type { TaskPriority } from '../../types/task';

interface TaskPriorityBadgeProps {
  priority: TaskPriority;
  size?: 'small' | 'medium';
  showIcon?: boolean;
}

const priorityConfig: Record<
  TaskPriority,
  { label: string; color: string; bgColor: string; icon: React.ReactNode }
> = {
  urgent: {
    label: 'Urgent',
    color: '#d32f2f',
    bgColor: '#ffebee',
    icon: <UrgentIcon fontSize="small" />,
  },
  high: {
    label: 'High',
    color: '#f57c00',
    bgColor: '#fff3e0',
    icon: <HighIcon fontSize="small" />,
  },
  medium: {
    label: 'Medium',
    color: '#1976d2',
    bgColor: '#e3f2fd',
    icon: <MediumIcon fontSize="small" />,
  },
  low: {
    label: 'Low',
    color: '#388e3c',
    bgColor: '#e8f5e9',
    icon: <LowIcon fontSize="small" />,
  },
};

export const TaskPriorityBadge: React.FC<TaskPriorityBadgeProps> = ({
  priority,
  size = 'small',
  showIcon = true,
}) => {
  const config = priorityConfig[priority] || priorityConfig.medium;

  return (
    <Chip
      label={config.label}
      size={size}
      icon={showIcon ? (config.icon as React.ReactElement) : undefined}
      sx={{
        color: config.color,
        backgroundColor: config.bgColor,
        borderColor: config.color,
        '& .MuiChip-icon': {
          color: config.color,
        },
      }}
      variant="outlined"
    />
  );
};

export default TaskPriorityBadge;
